import React, { ComponentClass, FunctionComponent } from "react";
import styles from "./Button.module.css";
import { IconBaseProps } from "react-icons";

interface ButtonProps {
  type?: "button" | "submit" | "reset" | undefined;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  icon?:
    | string
    | FunctionComponent<IconBaseProps>
    | ComponentClass<IconBaseProps, any>;
}

export default function Button({
  className,
  children,
  icon: Icon,
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      className={
        className === "primary"
          ? styles.primary
          : className === "secondary"
          ? styles.secondary
          : styles.google
      }
    >
      {Icon && React.createElement(Icon)}
      {children}
    </button>
  );
}
